import { supabase } from '../lib/supabase';

export type FeedbackCategory = 'Bug' | 'Idée' | 'Amélioration' | 'Question';

export interface FeedbackPayload {
  category: FeedbackCategory;
  message: string;
  userEmail?: string | null;
  userId?: string | null;
  route: string;
  timestamp: string;
}

class FeedbackService {
  /**
   * Submits a feedback payload to the backend Edge Function 'send-feedback'.
   */
  async submitFeedback(payload: FeedbackPayload): Promise<void> {
    const { data, error } = await supabase.functions.invoke('send-feedback', {
      body: payload,
    });

    if (error) {
      console.error('[FeedbackService] Function invocation error:', error);
      throw new Error(`Erreur réseau lors de l'envoi du feedback: ${error.message}`);
    }

    if (data?.error) {
      throw new Error(`Refus du serveur: ${data.error}`);
    }
  }
}

export const feedbackService = new FeedbackService();
